import type { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';
import { isSessionTimeoutStatus } from '@app/interceptor';
import type { SessionTimeoutService } from '@app/interface/session/session-timeout-service.interface';
import type { StorageService } from '@app/interface/storage/storage-service.interface';
import type { EventAction } from '@app/interface/action/event-action.interface';
import type { UserProfileStore } from '@app/interface/store/user-profile-store.interface';

@Injectable()
export class SessionTimeoutInterceptor implements HttpInterceptor {
  private sessionTimeoutAction: EventAction = inject(angularjs.SessionTimeoutAction);
  private userProfileStore: UserProfileStore = inject(angularjs.UserProfileStore);
  private sessionTimeoutService: SessionTimeoutService = inject<SessionTimeoutService>(angularjs.SessionTimeoutService);
  private storageService: StorageService = inject<StorageService>(angularjs.StorageService);
  private sessionRecreatedAction: EventAction = inject<EventAction>(angularjs.SessionRecreatedAction);
  constructor() {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(catchError((error) => this.handleError(error)));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    if (isSessionTimeoutStatus(error.status) && !this.sessionTimeoutService.isPendingSessionTimeout()) {
      this.sessionTimeoutService.setPendingSessionTimeout(true);
      this.sessionTimeoutAction.dispatch();

      void this.storageService.resetServer().finally(() => {
        this.sessionRecreatedAction.dispatch();
        void this.userProfileStore.loadIdentityUser();
      });
    }
    return throwError(() => error);
  }
}
